<template>
  <div class="modal-add-course">
    <div v-if="showModal">
          <transition name="modal">
              <div class="modal-mask">
                  <div class="modal-wrapper">
                  <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content">
                          <div class="modal-header">
                              <h5 class="modal-title">Plantilla por default</h5>
                              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                              <span aria-hidden="true" @click="toggleModal()">&times;</span>
                              </button>
                          </div>
                          <div class="modal-body">
                              <form action="#" @submit.prevent="submit">
                                  <div class="form-row">
                                      <div class="form-group col-12">
                                          <label for="defaultTemplateEmail" class="col-12 col-form-label text-left">Plantilla</label>
                                          <div class="info-email ml-3 text-secondary font-size-11px" style="font-size: 14px;">
                                            <p class="mb-0">Ayuda para envio de correo:</p>
                                            <ul>
                                              <li>{email}: Reemplazará el email del curso en la plantilla del correo.</li>
                                              <li>{nombre}: Reemplazará el nombre de la persona en el diploma.</li>
                                              <li>{apellido}: Reemplazará el apellido de la persona en el diploma.</li>
                                              <li>{curso}: Cambiará el texto por el nombre del curso en el cual ser dió el diplima.</li>
                                              <li>{link}: Será el link para que el usuario pueda ver sus resultados.</li>
                                              <li>{link_firma}: Cambiará el link para poder descargar la firma del diploma.</li>
                                              <li>{link_pdf}: Cambiará el link para poder descargar el diploma.</li>
                                            </ul>
                                          </div>
                                          <!-- <textarea class="form-control w-100" v-model="defaultTemplateEmail" name="defaultTemplateEmail" id="defaultTemplateEmail" cols="30" rows="10"></textarea> -->
                                          <editor
                                            api-key="no-api-key"
                                            v-model="defaultTemplateEmail"
                                            plugins="lists code"
                                            :init="{
                                              height: 600
                                            }"
                                          />
                                      </div>
                                  </div>

                                  <div class="form-group row mt-4">
                                      <div class="col-12 text-center">
                                        <span @click="updateTemplate()" class="btn btn-primary">Actualizar</span>
                                      </div>
                                  </div>
                              </form>
                          </div>
                      </div>
                  </div>
                  </div>
              </div>
          </transition>
      </div>
  </div>
</template>

<script>
import firebase from "firebase/app"
import 'firebase/firestore'
import 'firebase/storage'
import Editor from '@tinymce/tinymce-vue'

export default {
  name: "DefaultTemplate",
  computed: {
      showModal() {
        return this.$store.getters.addTemplateDefaultEmailShow
      },
  },
  async created() {
    this.defaultTemplateEmail = await this.getDefaultTemplate()
  },
  data() {
    return {
      defaultTemplateEmail: "",
    }
  },
  methods: {
      toggleModal() {
        this.$store.dispatch("toggleTemplateDefaultEmail")
      },
      updateTemplate(){
        firebase
          .firestore()
          .collection("config")
          .doc('general2020')
          .update({
              defaultTemplateEmail: this.defaultTemplateEmail
          })
          this.toggleModal()
          this.$toasted.show('Plantilla actualizada')
      },
      async getDefaultTemplate() {
        const configRef = firebase.firestore().collection("config").doc("general2020")
        const doc = await configRef.get()
        let data = doc.data()
        return data.defaultTemplateEmail
      }
  },
  components: {
    'editor': Editor
  }
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  -webkit-transition: opacity 500ms ease-in;
  -moz-transition: opacity 500ms ease-in;
  transition: opacity 500ms ease-in;
  overflow: auto;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
.modal-header {
  background-color: #007bff;
  color: #fefefe;
}
.modal-header span {
  color: #fefefe;
}
.modal-body {
  max-height: calc(100vh - 210px);
  overflow-y: auto;
}
.form-group {
  margin-bottom: 0 !important;
}
</style>

<style>
.tox.tox-silver-sink.tox-tinymce-aux{
  z-index: 999999;
}
.tox-menu.tox-collection.tox-collection--list.tox-selected-menu {
  z-index: 99999999999;
}
.tox-notifications-container{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/DefaultTemplate.vue